import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { delay, Observable, Subject, switchMap } from 'rxjs';

import { KeyphraseRow } from '../interfaces/KeyphraseExtraction';
import { TopicClassification } from '../interfaces/TopicClassification';
import { TableRequest, TableResponse, WebSocketResponse } from '../interfaces/WebSocketRequest';

@Injectable({
  providedIn: 'root',
})
export class BaseHttpService {
  constructor() {}

  private _httpClient = inject(HttpClient);

  private getkeyphrasesUrl = environment.requestUrls.basicUrl + environment.requestUrls.keyPhrases.getEndpoint
  private postKeyphrasesUrl = environment.requestUrls.basicUrl + environment.requestUrls.keyPhrases.postEnpoint

  private getTopicsUrl = environment.requestUrls.basicUrl + environment.requestUrls.topics.getEndpoint
  private postTopicsUrl = environment.requestUrls.basicUrl + environment.requestUrls.topics.postEnpoint

  public sendTopicClassificationUpdate(payload: TableRequest<TopicClassification>) {
    return this._httpClient.post<any>(this.postTopicsUrl, payload);
  }

  public getTopicTable(): Observable<TableResponse<TopicClassification>> {
    return this._httpClient.get<TableResponse<TopicClassification>>(
      this.getTopicsUrl + '/nrg_exp_topic_classification_definitions'
    );
  }

  public getKeyphraseTable(): Observable<TableResponse<KeyphraseRow>> {
    return this._httpClient.get<TableResponse<KeyphraseRow>>(
      this.getkeyphrasesUrl + '/nrg_key_phrases_definitions'
    );
  }

  public sendKeyphraseUpdate(payload: TableRequest<KeyphraseRow>): Observable<TableResponse<KeyphraseRow>> {
    return this._httpClient.post<TableResponse<KeyphraseRow>>(
      this.postKeyphrasesUrl , payload
    );
  }

  // public getHello(): Observable<WebSocketResponse<TopicClassification>> {
  //   return this._httpClient.get<WebSocketResponse<TopicClassification>>(
  //     this.getUrl + '/hello'
  //   );
  // }
}
